<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul class="list-nav">
      <li class="nav-item nav-item-home">
        <router-link class="nav-link" :to="{ path: getMenu[0].path }">
          INICIO
        </router-link>
      </li>
      <!-- Divider -->
      <hr class="sidebar-divider-1" />
      <li v-for="(entry, index) in getMenu.slice(1, getMenu.length)" :key="index" class="nav-item">
        <a
          class="nav-link d-flex justify-content-between align-items-center"
          :id="'btn-menu' + entry.id"
          @click.prevent="activeMenu(entry.id)"
        >
          {{ entry.name }}
          <span class="">
            <span
              v-if="entry.children.length > 0"
              class="menu-arrow"
            />
          </span>
        </a>
        <hr class="sidebar-divider-1" />
        <div class="box-menu" :id="'box-menu' + entry.id">
          <div
            class="list-box-menu"
            v-for="item of entry.children"
            :key="item.id"
          >
            <router-link
              class=""
              v-if="(!item.admin_required  || getIsSuperAdmin)"
              :to="{ path: item.path }"
              @click.prevent="activeMenu(item.id)"
              >{{ item.name }}
            </router-link>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <!-- End Sidebar -->
</template>

<script>
import { authComputed, authMethods } from '@state/helpers'

export default {
  components: {},
  props: {
    isCondensed: {
      type: Boolean,
      required: false,
    },
    toggleMenu: {
      type: Function,
      required: false,
      default: () => { },
    },
  },
  computed: {
    ...authComputed,
    getMenu: function () {
      return this.$store.state.auth.currentSession
        ? this.$store.state.auth.currentSession.user.app_sections_tree
        : []
    },
    getIsSuperAdmin: function () {
      return this.$store.state.auth.currentSession.user.is_superuser
    }
  },
  mounted() {},
  created: function () {
    if (this.loggedIn) {
      this.setUserActiveSection(this.$route.path)
    }
  },
  methods: {
    ...authMethods,
    logout() {
      const me = this;
      me.$router.push({name: 'logout'});
    },
    activeMenu(id) {
      let idMenu = null;
      const box = document.getElementById(`box-menu${id}`);
      const boxActive = document.querySelector(".active-box");
      const overlay = document.getElementById("overlay-menu");

      if (boxActive) {
        idMenu = boxActive.id;
        boxActive.classList.remove("active-box");
        overlay.classList.remove("active-overlay");
      }

      if (idMenu && box.id == idMenu) {
        boxActive.classList.remove("active-box");
        overlay.classList.remove("active-overlay");
      } else {
        box.classList.add("active-box");
        overlay.classList.add("active-overlay");
      }
    },
  },
}
</script>

<style lang="scss">
.list-nav {
  list-style: none !important;
  margin: 0 !important;
  padding-left: 0 !important;
}

.nav-item  {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.nav-item a {
  font-family: 'Montserrat', sans-serif !important;
  font-size: 12px !important;
  color: #6e768e !important;
  text-transform: capitalize !important;
  -webkit-transition:all 0.2s linear;
  -moz-transition:all 0.2s linear;
  -o-transition:all 0.2s linear;
  transition:all 0.2s linear;
  cursor: pointer;
  padding: 13px 20px 12px 30px !important;
}

.nav-item-home {
  padding-top: 15px !important;
}

.nav-item a.active {
  color: #245E8E !important;
  font-weight: 600 !important;
}

.nav-item a:hover {
  background-color: #92BEE4 !important;
  color: #ffffff !important;
  font-weight: normal !important;
}

.nav-link {
  padding: 0.75rem 1rem !important;
}

.nav-link.router-link-active {
  color: #245E8E !important;
  font-weight: 600 !important;
}

.sidebar-divider-1 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.box-menu {
  position: fixed;
  will-change: transform;
  top: 54px;
  left: 5px;
  height: 100%;
  z-index: 1000;
  width: 240px;
  padding-top: 68px;
  padding-bottom: 70px;
  margin: 0.125rem 0 0;
  font-size: 0.85rem;
  color: #000000;
  text-align: left;
  list-style: none;
  background-color: #f0f0f0;
  background-clip: padding-box;
  border: none;
  display: none;
  border-radius: 0.35rem;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-border-radius: 0;
  animation: fadeInAnimation ease .8s;
  -webkit-animation: fadeInAnimation ease .8s;
  overflow: hidden;
  box-sizing: border-box;
  overflow-y: auto;
  transform: translate3d(235px, 10px, 0px);
  -webkit-transform: translate3d(235px, 10px, 0px);
  -moz-transform: translate3d(235px, 10px, 0px);
  -ms-transform: translate3d(235px, 10px, 0px);
  -o-transform: translate3d(235px, 10px, 0px);
}

@keyframes fadeInAnimation {
  0% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

.list-box-menu {
  width: 100%;
  border-bottom: 0.5px solid #e2e2e2;
}

.box-menu.active-box {
  display: flex;
  flex-direction: column;
}

.box-menu.top {
  transform: translate3d(288px, -80px, 0px);
  -webkit-transform: translate3d(288px, -80px, 0px);
  -moz-transform: translate3d(288px, -80px, 0px);
  -ms-transform: translate3d(288px, -80px, 0px);
  -o-transform: translate3d(288px, -80px, 0px);
}

.list-box-menu a {
  position: relative;
  display: block;
  padding: 13px 20px 12px 50px;
  color: #6e768e !important;
  text-decoration: none;
  
  -webkit-transition:all 0.2s linear;
  -moz-transition:all 0.2s linear;
  -o-transition:all 0.2s linear;
  transition:all 0.2s linear;  
}

.list-box-menu a.router-link-exact-active {
  background-color: #92BEE4 !important;
  color: #fff !important;
} 

.list-box-menu a:hover {
  background-color: #c3d6e6 !important;
  color: #fff !important;
}

.overlay-menu
{
	position: fixed;
	top: 65px;
	left: 13.40rem;
	width: 90%;
	height: 100%;
	right: 0;
	background-color: #cddae5;
	opacity: 0.9;
	z-index: 100;
  display: none;
	transition: .4s ease-in;
	transition: .4s ease-out;
	-webkit-transition: .4s ease-in;
	-moz-transition: .4s ease-in;
	-ms-transition: .4s ease-in;
	-o-transition: .4s ease-in;
}

.overlay-menu.active-overlay {
  display: block;
}

#sidebar-menu .menu-arrow {
  line-height: 0.2rem !important;
}
</style>
